// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class StaticDatum extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  staticDataItemId!: number;
  allowAddNew?: boolean;
  allowDeleteFromId?: number;
  allowEditFromId!: number;
  collectionProgId?: string;
  controlProgId?: string;
  createdBy!: string;
  createdDate!: Date;
  displayName!: string;
  isStandard!: boolean;
  managerProgId?: string;
  memberProgId?: string;
  objectName!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
}

